import { render, staticRenderFns } from "./CreateBookingView.vue?vue&type=template&id=6af9ba0c&scoped=true"
import script from "./CreateBookingView.vue?vue&type=script&lang=js"
export * from "./CreateBookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9ba0c",
  null
  
)

export default component.exports